module.exports = __webpack_public_path__ + "img/img8.18ce0be6.jpg";